import { gql } from "@apollo/client";

export const GetCheckInMany = gql`
  query CheckInMany($locationId: String, $todayRecords: Boolean) {
    checkInMany(locationId: $locationId, todayRecords: $todayRecords) {
      id
      createdDate
      isAccepted
      client {
        memberships {
          id
          status
          subscription {
            paymentStatus
          }
          location {
            id
          }
          termStart
          termEnd
        }
        user {
          firstName
          lastName
          profilePicUrl
        }
        memberStatus
        leadStatus
      }
    }
  }
`;

// fetch same data as CheckInMany to make it merge with checkInMany data
export const GetnewCheckIn = gql`
  subscription GetnewCheckIn($locationId: String!) {
    createCheckInSubscription(locationId: $locationId) {
      newCheckIn {
        id
        createdDate
        isAccepted
        client {
          memberships {
            id
            status
            subscription {
              paymentStatus
            }
            location {
              id
            }
            termStart
            termEnd
          }
          user {
            firstName
            lastName
            profilePicUrl
          }
          memberStatus
          leadStatus
        }
      }
    }
  }
`;

export const GetCheckInOne = gql`
  query GetCheckInOne($checkInOneId: String!) {
    checkInOne(id: $checkInOneId) {
      id
      isAccepted
      isOverride
      createdDate
      client {
        id
        user {
          firstName
          lastName
          profilePicUrl
        }
        dob
        memberStatus
        leadStatus
        memberships {
          id
          status
          subscription {
            paymentStatus
          }
          location {
            id
          }
          isAutoRenew
          termStart
          termEnd
          agreement {
            id
            name
          }
        }
      }
      isAccepted
      isOverride
    }
  }
`;
